import { Component, AfterViewInit, OnInit } from '@angular/core';
import { Http, RequestOptions, Headers, Response } from '@angular/http';
//import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { FeedbackService, FeedbackItem} from '../app/FeedbackService';
//When a call comes in the x method will fire - start tracing the code from there.
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewInit, OnInit {
  title = 'Connect Feedback';
  HappyImageUrl;
  HappyImageAlt;
  OKImageUrl;
  OKImageAlt;
  NeutralImageUrl;
  NeutralImageAlt;
  SadImageUrl;
  SadImageAlt;
  VerySadImageUrl;
  VerySadImageAlt;
  ShowOptions;
  ShowThankYou;
  ShowComment;
  CommentText;
  CurrentScore;
  CurrentOrdinal;
  CurrentFeedback;
  isFloating;
  positionTop;
  positionLeft;
  positionRight;
  divWidth;
  public settings = new Settings();

  constructor(private http: Http, private FBService: FeedbackService) {
    console.log("Start constructor");
  }

  async ngOnInit() {
    console.log("Start ngOnInit");
    //this.logMessage += "Start ngOnInit\n";
    
  }

  //This is the first real processing routine. It handles the incomming phone number
  async ngAfterViewInit() {
    console.log("Start ngAfterViewInit");
    //this.logMessage += "Start ngAfterViewInit\n";  //<br/> \n

    //Get configuration settings and set the page title.
    //The configuration settings method also grabs the incoming number out of the URL and cleanses it ready for matching
    this.settings = await this.getConfigureSettings();
    this.title = this.settings.config_iPartTitle;
    this.HappyImageUrl = this.settings.config_HappyImageUrl;
    this.HappyImageAlt = this.settings.config_HappyImageAlt;
    this.OKImageUrl = this.settings.config_OKImageUrl;
    this.OKImageAlt = this.settings.config_OkImageAlt;
    this.NeutralImageUrl = this.settings.config_NeutralImageUrl;
    this.NeutralImageAlt = this.settings.config_NeutralImageAlt;
    this.SadImageUrl = this.settings.config_SadImageUrl;
    this.SadImageAlt = this.settings.config_SadImageAlt;
    this.VerySadImageUrl = this.settings.config_VerySadImageUrl;
    this.VerySadImageAlt = this.settings.config_VerySadImageAlt;
    this.ShowOptions = true;
    this.ShowThankYou = false;
    this.ShowComment = false;
    this.CommentText = "";
    this.isFloating = this.settings.config_Float;
    this.divWidth = this.settings.config_DisplayWidth;
    if (this.settings.config_AnchorRight) {
      this.positionLeft = "auto";
      this.positionRight = this.settings.config_SidePadding;
    }
    else {
      this.positionLeft = this.settings.config_SidePadding;
      this.positionRight = "auto";
    }
    this.positionTop = this.settings.config_VerticalPosition;
    this.CurrentFeedback = new FeedbackItem();
    console.log("OK button URL from config = " + this.OKImageUrl);
    console.log("ngAfterViewInit Finish");
  }

  async getConfigureSettings(): Promise<Settings> {
    console.log("Start getConfigureSettings()");

    // if not set, get settings from Rise using http call
    //if (this.settings == null) {
      console.log("run getSettings using http get!");

      const contentKey = document.querySelector('#runtimecontainer').getAttribute('data-asi-contentkey');
      const contentItemKey = document.querySelector('#runtimecontainer').getAttribute('data-asi-contentitemkey');

      console.log("contentKey = ", contentKey);
      console.log("contentItemKey = ", contentItemKey);

      // get settings from Rise with http get
      this.settings = await this.getSetting(contentKey, contentItemKey);
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
    //}
    //else
    //  console.log("already have this.settings, bypass run getSettings and http get!");

    console.log("this.settings = ", this.settings);
    return this.settings;
  }

  async getSetting(contentKey: string, contentItemKey: string): Promise<Settings> {
    console.log("Start getSetting()");

    // if settings exist, just return, do not need to get from Rise
    //if (this.settings != null && this.settings != undefined) {
    //  console.log("getSetting - got this.settings, bypass http get! this.settings =", this.settings);

    //  return this.settings; // wrapped in Promise
    //}
    //else
      console.log("getSetting - run http get!");

    console.log("getSetting window.location.host", window.location.host);

    const host = window.location.host;
    let provider = `${host}`;
    let virtualDirectory = '';

    const hasVirtualDirectory = document.querySelector('script[src^="/AsiCommon"]') === null;

    console.log("getSetting hasVirtualDirectory", hasVirtualDirectory);
    console.log("getSetting provider", provider);

    if (hasVirtualDirectory) {
      virtualDirectory = window.location.href.split('/')[3];
      provider = `${provider}${virtualDirectory}`;
      virtualDirectory = `/${virtualDirectory}`;
    }

    console.log("getSetting virtualDirectory", virtualDirectory);

    const options = new RequestOptions({
      headers: new Headers({ 'RequestVerificationToken': document.querySelector('#__RequestVerificationToken').getAttribute('value') })
    });

    console.log("getSetting options", options);
    let resp: Response; // holds http response

    try {
      resp = await this.http
        .get(`${virtualDirectory}/api/ContentItem?ContentKey=${contentKey}&ContentItemKey=${contentItemKey}`, options).toPromise();
    } catch (e) {
      console.log("getSetting catch error. message = ", e);
      return new Settings(); 
    }

    console.log("getSetting resp", resp);
    console.log("getSetting resp.json()", resp.json());
    console.log("getSetting resp.json().Settings", resp.json().Settings);

    let settings: Settings;

    if (resp.json().Settings === undefined)
      settings = resp.json().Items.$values[0].Data.Settings; // iMIS 2017
    else
      settings = resp.json().Settings; // iMIS 20.3

    console.log("NEW settings:", settings);

    return settings;
  }
  IsUserLoggedIn() {
    const paramElement = document.querySelector("param#__ClientContext") as HTMLParamElement;
    if (paramElement) {
      const jsonString = paramElement.value;
      try {
        const clientContext = JSON.parse(jsonString);
        console.log(clientContext); // Access properties like clientContext.tenantId
        return !clientContext["isAnonymous"];
      } catch (e) {
        console.error("Invalid JSON in param value:", e);
        return false;
      }
    } else {
      console.error("Param element not found.");
      return false;
    }
    return false;
  }
  async FeedbackClick(FbackScore: number) {
    const SelectedID = await this.GetSelectedContactID();
    this.ShowOptions = false;
    this.ShowComment = true;
    console.log("FeedbackClick Score: " + FbackScore + " Current Comment= " + this.CommentText);
    this.CurrentFeedback.Score = FbackScore;
    this.CurrentFeedback.Ordinal = -1;
    var FeedbackPage = "No Idea";
    if (this.settings.config_UsePageTitle) { FeedbackPage = document.title; }
    if (this.settings.config_UseURL) { FeedbackPage = location.href; }
    if (this.settings.config_UseFixedTitle) { FeedbackPage = this.settings.config_SurveyTitle; }
    if (this.IsUserLoggedIn()) {
      console.log("User is logged in. going to make local call to log feedback");
      this.CurrentFeedback = await this.FBService.LogFeedback(SelectedID, this.CommentText, FbackScore, FeedbackPage, -1, this.settings);
    }
    else {
      console.log("User Not logged in - going to use service");
      this.CurrentFeedback = await this.FBService.LogFeedback(SelectedID, this.CommentText, FbackScore, FeedbackPage, -1, this.settings);
    }
  }
  async SaveComment() {
    console.log("Would save feedback " + this.CommentText);
    const SelectedID = await this.GetSelectedContactID();
    this.ShowOptions = false;
    this.ShowComment = false;
    this.ShowThankYou = true;
    var FeedbackPage = document.title;
    if (this.settings.config_UseURL) { FeedbackPage = location.href; }
    if (this.settings.config_UseFixedTitle) { FeedbackPage = this.settings.config_SurveyTitle; }
    //if (this.IsUserLoggedIn()) {
    //  console.log("User is logged in. make local call to log feedback");
    //  this.CurrentFeedback = await this.FBService.LogFeedback(SelectedID, this.CommentText, this.CurrentFeedback.Score, FeedbackPage, this.CurrentFeedback.Ordinal, this.settings);
    //}
    //else {
    //  console.log("User is not logged in. User Service");
    this.CurrentFeedback = await this.FBService.LogFeedback(SelectedID, this.CommentText, this.CurrentFeedback.Score, FeedbackPage, this.CurrentFeedback.Ordinal, this.settings);
    //}
  }
  async GetSelectedContactID(): Promise<string> {
    const param = document.querySelector('param#__ClientContext') as HTMLParamElement | null;

    if (param) {
      const rawValue = param.value;
      const decoded = rawValue.replace(/&quot;/g, '"');

      try {
        const context: ClientContext = JSON.parse(decoded);
        const selectedPartyId = context.selectedPartyId;
        console.log('Selected Party ID:', selectedPartyId);
        return selectedPartyId;
      } catch (error) {
        console.error('Failed to parse client context:', error);
        return "23736"; // 217";
      }
    }
    else {
      return "217";
    }
  }
  

}
interface ClientContext {
  baseUrl: string;
  isAnonymous: boolean;
  tenantId: string;
  loggedInPartyId: string;
  selectedPartyId: string;
  websiteRoot: string;
  virtualDir: string;
  appTimeZoneOffset: number;
  cookieConsent: number;
}
export class Settings {
  public config_iPartTitle: string;
  public config_ClientID: number;
  public config_ImageSet: string;
  public config_HappyImageUrl: string;
  public config_HappyImageAlt: string;
  public config_OKImageUrl: string;
  public config_OkImageAlt: string;
  public config_NeutralImageUrl: string;
  public config_NeutralImageAlt: string;
  public config_SadImageUrl: string;
  public config_SadImageAlt: string;
  public config_VerySadImageUrl: string;
  public config_VerySadImageAlt: string;
  public config_Float: boolean;
  public config_VerticalPosition: string;
  public config_DisplayWidth: string;
  public config_AnchorRight: boolean;
  public config_SidePadding: string;
  public config_UsePageTitle: boolean;
  public config_UseURL: boolean;
  public config_UseFixedTitle: boolean;
  public config_SurveyTitle: string; 
}
